import React from 'react';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { Input } from '@thd-olt-component-react/input';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import Field from '../../common/Field/Field';
import { DESCRIPTION_CHAR_LIMIT, NAME_CHAR_LIMIT } from '../../../utils/constants';
import { jobPostingValidators } from '../../../utils/validations';
import { generateImageSource } from '../../../utils/generateImageSource';

export const CompanyProfileDetails = ({
  profile,
  setProfile
}) => {

  return (
    <div className="ptp-company-profile__details-section">
      <Row>
        <Col>
          <div className="p2p-field__label">
            Company Name
          </div>
          <div className="ptp-company-profile__company-name-section">
            <div className="ptp-company-profile__company-name">
              {profile?.name}
            </div>
            <div className="ptp-company-profile__company-update">
              <a
                href="https://www.homedepot.com/myaccount/profile"
                target="_blank"
                rel="noreferrer noopener"
                className="ptp-company-profile__company-name-link"
                data-testid="company-name-change-link"
              >
                Update Company Name
              </a>
              <div>
                <Tooltip
                  channel="desktop"
                  content={<ToolTipContent />}
                  className="ptp-company-profile__tool-tip"
                >
                  <img
                    className="ptp-company-profile__tool-tip-icon"
                    src={generateImageSource('/images/v1/info.svg')}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="ptp-company-profile__url-section">
          <Field
            label="Company URL"
            dirty={false}
            showError={false}
          >
            <Input
              value={profile?.url}
              validateOnBlur={!!profile?.url}
              maxLength={NAME_CHAR_LIMIT}
              errorText="Please provide a valid url"
              onChange={(newValue) => setProfile({ ...profile, url: newValue })}
              validation={() => jobPostingValidators.companyUrl({ companyUrl: profile.url })}
              name="companyUrl"
            />
          </Field>
        </Col>
      </Row>

      <Row>
        <Col className="ptp-company-profile__description-section">
          <Field
            label="Company Description"
            description="Describe your company and the type of work it provides."
          >
            <Input
              type="textarea"
              name="companyDescription"
              value={profile.description}
              maxLength={DESCRIPTION_CHAR_LIMIT}
              onChange={(newValue) => setProfile({ ...profile, description: newValue })}
              className="create-job-posting__textarea"
              rows="6"
            />
          </Field>
        </Col>
      </Row>
    </div>
  );
};

const ToolTipContent = () => {
  return (
    <p>Company Name is saved on your Pro Xtra account. Only Pro Xtra{' '}
      <b>Account Owners</b> can update a Company Name. You will still be
      able to edit your Company Name on individual job postings.
    </p>
  );
};
